import jmEducationSelect from './select/educationSelect.vue';
import jmLessonSelect from './select/lessonSelect.vue';
import jmExamjpSelect from './select/examjpSelect.vue';
import jmStudytargetSelect from './select/studytargetSelect.vue';
import crumbs from './crumbs.vue';
import sidebar from './sidebar.vue';
import jmChannel from './channel.vue';
import jmAreaselect from './select/areaSelect.vue';
import jmLinkage from './selectLinkage.vue';
import jmDictSelect from './select/dictSelect.vue';
import jmUpload from './upload.vue';

const jmUploadFile = () => import('./uploadFile.vue');
const jmAssetUpload = () => import('./assetUpload');
const jmSchoolSearch = () => import('./schoolSearch.vue');
const jmSearch = () => import('./search/search.vue');
const jmSchoolOrgSearch = () => import('./schoolOrgSearch.vue');

export {
  sidebar,
  crumbs,
  jmAreaselect,
  jmChannel,
  jmSchoolSearch,
  jmSearch,
  jmEducationSelect,
  jmLessonSelect,
  jmDictSelect,
  jmUploadFile,
  jmSchoolOrgSearch,
  jmExamjpSelect,
  jmStudytargetSelect,
  jmLinkage,
  jmAssetUpload,
  jmUpload,
};
